// app/studente/incarichi.js

(function () {
    'use strict';
    var controllerId = 'incarichiCtr';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', incarichiCtr]);

    function incarichiCtr(common, bDialog, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'Docenze';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.records = [];
        vm.countRecords = 0;

        vm.page = 1;
        vm.loading = false;

        //Filtro
        vm.filter = {};
        vm.filter.nominativo = ' ';        
        vm.filter.classeId = 0;
        vm.fNominativo;        
        vm.fClasseId;

        //Elenchi per filtri e finestra modale di Create e Update
        vm.classi = [];
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getByFilter;

        vm.addRecord = open;

        vm.get = getDetail;
        vm.delete = deleteItem;


        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getClassi()];
            common.activateController(promises, controllerId)
                    .then(function () { });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.nominativo = vm.fNominativo == null ? '' : vm.fNominativo;            
            vm.filter.classeId = vm.fClasseId == null ? 0 : vm.fClasseId;

            vm.loading = false;
            countByFilter();
            return getByFilter();
        }

        function countByFilter() {
            return datacontext.countIncarichiByFilter(vm.filter.nominativo, vm.filter.classeId)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.getIncarichiByFilter(vm.page, vm.filter.nominativo, vm.filter.classeId)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getDetail(id) {
            return datacontext.getIncaricoBase(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function deleteItem(item) {            
            var msg = ' Incarico di ' + item.Risorsa + ' da Classe ' + item.ClasseId;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.deleteIncarico(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Elenchi Parametri

        function getClassi() {
            return datacontext.getClassi().then(function (data) {
                return vm.classi = data;
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function open() {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incarico/modal/incaricoAddEdit.html?version=43',
                controller: 'incaricoAddEdit',
                resolve: {
                    classi: function () {
                        return vm.classi;
                    },
                    classeId: function () {
                        return null;
                    },
                    risorsaId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getDetail(returnItem.Id);
            });
        };
    }
})();
